import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    ValidationMessage,
    ValidationMessageType,
    SettingState,
    TibboDataType,
    SettingOption,
    Define,
} from '@appblocks/codegeneration/types';
import * as micropython from './micropython';
import * as tios from './tios';


export default class StgcmdLib extends BaseFeature {
    constructor() {
        super();
        this.name = 'Settings and Commands Library';
        this.id = 'stgcmd_lib';
        this.fileLinks = [
        ];
    }

    getFiles(): string[] {
        if (this.project.runtime === 'tios') {
            return [
                'libraries/stgcmd/stgcmd.tbh',
                'libraries/stgcmd/stgcmd.tbs',
            ];
        }
        return [];
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case 'simulator':
                return [];
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `
## Stgcmd library
Settings and system commands API
        `;
    }
}
